const smtCodeResultPreviewComponent = {
  // The component reads components.codeResultPreview.text.color for the
  // result body. Without this entry Chakra emitted the token path as literal
  // CSS, which browsers drop, so the text fell back to whatever it inherited.
  text: {
    color: {
      default: 'gray.700',
      _dark: 'gray.300'
    }
  },
  header: {
    bgColor: {
      default: 'gray.100',
      _dark: '#011a2f'
    },
    text: {
      color: {
        default: 'gray.600',
        _dark: 'gray.400'
      }
    }
  },
  noResult: {
    text: {
      color: {
        default: 'gray.400',
        _dark: 'gray.500'
      }
    }
  },
  loadingSpinner: {
    color: {
      default: 'gray.400',
      _dark: 'gray.500'
    }
  },
  borderColor: {
    default: 'gray.200',
    _dark: 'rgba(45, 55, 72, 0.75)'
  }
};

export default smtCodeResultPreviewComponent;
